import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod/v3';

import { vendorLayoutRoute } from '../VendorLayout';

const vendorDocumentsSearchSchema = z.object({
  deleteId: z.string().optional(),
  editId: z.string().optional(),
  createModalOpen: z.boolean().optional(),
});

export const vendorDocumentsRoute = createRoute({
  getParentRoute: () => vendorLayoutRoute,
  path: 'documents',
  component: lazyRouteComponent(() => import('./VendorDocumentsView')),
  validateSearch: (search) => vendorDocumentsSearchSchema.parse(search),
});

export const vendorContractsRoute = createRoute({
  // @todo: deprecated route. safe to remove
  getParentRoute: () => vendorLayoutRoute,
  path: 'contracts',
  component: lazyRouteComponent(() => import('./VendorDocumentsView')),
  validateSearch: (search) => vendorDocumentsSearchSchema.parse(search),
});
